import { ReactElement } from 'react'
import { Outlet } from 'react-router-dom'

import Navbar from '@components/Navbar'
import Footer from '@components/Footer'
import MainLayout from '@components/MainLayout'
import ErrorFallback from '@components/ErrorFallback'
import SuspenseWrapper from '@components/SuspenseWrapper'

const AppLayout = (): ReactElement => {
  return (
    <>
      <main className='main h-full overflow-hidden'>
        <Navbar />
        <MainLayout>
          <SuspenseWrapper
            loadingMessage='ページを読み込んでいます...'
            minimal={true}
          >
            <Outlet />
          </SuspenseWrapper>
        </MainLayout>
      </main>
      <Footer />
      <ErrorFallback />
    </>
  )
}

export default AppLayout
